import React from "react";
import Highlight, { defaultProps } from "prism-react-renderer";

import styles from './styles.module.less';

import CopyButton from './CopyButton';
import normalize from './normalize';

import TerminalIcon from '../../../static/images/doc-icons/terminal.inline.svg';
import CodeIcon from '../../../static/images/doc-icons/code.inline.svg';

const getParams = (name = '') => {
  const [lang, params = ''] = name.split(':');
  return [
    lang
      .split('language-')
      .pop()
      .split('{')
      .shift(),
  ].concat(
    params.split('&').reduce((merged, param) => {
      const [key, value] = param.split('=');
      merged[key] = value;
      return merged
    }, {})
  )
};

/*
 * MDX passes the code block as JSX
 * we un-wind it a bit to get the string content
 * but keep it extensible so it can be used with just children (string) and className
 */
export default ({
  children,
  className = children.props ? children.props.className : '',
}) => {
  const [language, { title = '' }] = getParams(className);
  const [content, highlights] = normalize(
    children.props && children.props.children
      ? children.props.children
      : children,
    className
  );

  return (
    <Highlight
      {...defaultProps}
      code={content}
      language={language}
      theme={undefined}
    >
      {({ tokens, getLineProps, getTokenProps }) => (
        <div className={styles.CodeBlock__light}>
            <div className={styles.CodeBlock__header}>
                <label>
                    { language ? <CodeIcon />  : <TerminalIcon /> }
                    { language ? language : 'Terminal' }
                </label>
                <CopyButton
                  fileName={title}
                  content={content}
                />
            </div>
            <pre className={`language-${language}`}>
                {tokens.map((line, i) => {
                  const lineProps = getLineProps({ line, key: i });
                  const className = [lineProps.className]
                    .concat(highlights[i] && 'gatsby-highlight-code-line')
                    .filter(Boolean)
                    .join(' ');
                  return (
                    <div
                      key={i}
                      {...Object.assign({}, lineProps, {
                        className,
                      })}
                    >
                      {line.map((token, key) => (
                        <span key={key} {...getTokenProps({ token, key })} />
                      ))}
                    </div>
                  )
                })}
            </pre>
        </div>
      )}
    </Highlight>
  )
}
